import pipelineWebhooksAPI from 'dashboard/api/pipeline/webhooks';

const state = {
  webhooks: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isTesting: false,
  },
};

const getters = {
  allWebhooks: $state => $state.webhooks,
  uiFlags: $state => $state.uiFlags,
};

const actions = {
  get: async ({ commit }) => {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await pipelineWebhooksAPI.get();
      commit('SET_WEBHOOKS', data.payload);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  create: async ({ commit }, webhookObj) => {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const { data } = await pipelineWebhooksAPI.create(webhookObj);
      commit('ADD_WEBHOOK', data);
      return data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  update: async ({ commit }, { id, ...updateObj }) => {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await pipelineWebhooksAPI.update(id, updateObj);
      commit('UPDATE_WEBHOOK', data);
      return data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  delete: async ({ commit }, id) => {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await pipelineWebhooksAPI.delete(id);
      commit('DELETE_WEBHOOK', id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },

  test: async ({ commit }, id) => {
    commit('SET_UI_FLAG', { isTesting: true });
    try {
      const { data } = await pipelineWebhooksAPI.test(id);
      return data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit('SET_UI_FLAG', { isTesting: false });
    }
  },

  regenerateSecret: async ({ commit }, id) => {
    try {
      const { data } = await pipelineWebhooksAPI.regenerateSecret(id);
      commit('UPDATE_WEBHOOK', data);
      return data;
    } catch (error) {
      throw new Error(error);
    }
  },
};

const mutations = {
  SET_UI_FLAG($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  SET_WEBHOOKS($state, webhooks) {
    $state.webhooks = webhooks;
  },
  ADD_WEBHOOK($state, webhook) {
    $state.webhooks.push(webhook);
  },
  UPDATE_WEBHOOK($state, webhook) {
    const index = $state.webhooks.findIndex(w => w.id === webhook.id);
    if (index !== -1) {
      $state.webhooks.splice(index, 1, webhook);
    }
  },
  DELETE_WEBHOOK($state, id) {
    $state.webhooks = $state.webhooks.filter(w => w.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
